'use client';

import { ButtonLink } from '@sortlist-frontend/design-system/ssr';
import { useTrack } from '@sortlist-frontend/tracking';
import type { MouseEvent } from 'react';

import { useBriefingLink } from '_components/Briefing/hooks/useBriefingLink';
import { NavigationData } from '_components/layout/Layout';

interface Props {
  label: string;
  navigationData: NavigationData;
  pageId?: string;
}

export const BriefingHeroCta = (props: Props) => {
  const { label, navigationData, pageId } = props;
  const { onClick, ...briefingLink } = useBriefingLink({ cta: 'hero', expertiseId: navigationData.expertiseId });
  const { track } = useTrack({ app: 'public', locale: navigationData.locale });

  const handleClick = (event: MouseEvent<HTMLAnchorElement>) => {
    if (pageId != null) {
      track({ slug: 'getMatched', data: { pageId, origin: 'originHeader' } });
    }
    onClick(event);
  };

  return (
    <ButtonLink
      size="lg"
      buttonStyle="secondary"
      buttonVariant="raised"
      className="mb-2 sm:mt-5 mx-6 lg:px-12"
      data-testid="briefing-hero-btn"
      label={label}
      {...briefingLink}
      onClick={handleClick}
    />
  );
};
